<template>
    <div>
        <!-- tab -->
        <div class="navbox">
            <div class="nav">
                <p :class="{navactived : navtabcurrentindex == index}" @click="handletab(index)" v-for="(change,index) of changeArr" :key="index">{{change.name}}</p>
            </div>
        </div>
        <div class="isloginTips" v-show="loadingShow">
            <img src="@/assets/loading.png" alt="">
            <p>提交中...</p>
        </div>
        <div class="timebox" v-show="timepickershow">
            <div class="timeboxwrapper">
                <div class="title">选择挂单有效期</div>
                <ul>
                    <li>年</li>
                    <li>月</li>
                    <li>日</li>
                    <li>时</li>
                    <li>分</li>
                </ul>
                <van-datetime-picker v-model="currentDate" type="datetime" :min-date="minDate" :max-date="maxDate" @change="onchange" visible-item-count="3" :show-toolbar="false"/>
            </div>
            <div class="timebtn">
                <p @click="confirmremove">取消</p>
                <p @click="confirmPicker">确定</p>
            </div>
        </div>

        <!-- 市价交易 -->
        <div class="content" v-show="this.navtabcurrentindex == 0">
            <p class="contenttips">市价模式下的成交价格，可能会与请求价格有一定差异。</p>

            <div class="price">
                <div class="left">
                    <p>卖出市价</p>
                    <p>{{this.$store.state.goldSell?this.$store.state.goldSell.toFixed(2):'--.--'}}</p>
                </div>
                <div class="main">
                    <p>点差</p>
                    <p>{{spread}}</p>
                </div>
                <div class="right">
                    <p>买入市价</p>
                    <p>{{this.$store.state.goldBuy?this.$store.state.goldBuy.toFixed(2):'--.--'}}</p>
                </div>
            </div>
            <div class="dealbox">
                <div class="left">
                    <p>交易手数</p>
                </div>

                <div class="ctrlbox">
                    <div class="main"><img @click="totalcut" src="@/assets/cut.png" alt=""></div>
                    <div class="right">
                        <span><input type="num" placeholder="手数" v-model.number="initlot" @input="oninput" @focus="onfocuss" @blur="onblur"></span>
                        <span><img @click="totaladd" src="@/assets/add.png" alt=""></span>
                        <span @click="resetnum()">清空</span>
                    </div>
                </div>

            </div>

            <dealprices @goldzhisunds='getzhisunds' @goldzhiyingds='getzhiyingds' @zhiying='mentss' @zhisun='mentsss' :yfk='yfk' @lotsarr='lotsarrs' :initlot='Number(this.initlot)' ></dealprices>
            <div class="buybox">
                <div class="sell" @click="handleSell">市价卖出</div>
                <div class="buy" @click="handleBuy">市价买入</div>
            </div>

            <!-- 市价卖出弹出框 -->
            <div class="mask" @click="handlemask" v-show="sellBoxShow || buyBoxShow"></div>
            <div class="Sellbox" v-show="sellBoxShow || buyBoxShow">
                <div class="title">确认订单信息</div>
                <div class="sellContent">
                    <div class="top">
                        <span :style="{backgroundColor:sellBoxShow?'#17CF84':(buyBoxShow?'#FF4F36':'#999999')}">{{sellBoxShow?'市价卖出':(buyBoxShow?'市价买入':'请选择')}}</span>
                        <span>{{this.$store.state.goldindex?'伦敦金':'伦敦银'}}</span>
                        <span>{{initlot+'手'}}</span>
                    </div>
                    <ul>
                        <div class="left">
                            <li>交易价格<span>市价</span></li>
                            <li>最新价格<span>{{this.navtabcurrentindex == 0 && sellBoxShow?getparsefloatsell:getparsefloatbuy}}</span></li>
                        </div>
                        <div class="right">
                            <li>止损<span>{{!this.zhisunds && this.goldzhisun && this.navtabcurrentindex == 0?parseFloat(this.goldzhisun).toFixed(2):(this.zhisunds && !this.goldzhisun && this.navtabcurrentindex == 0 && sellBoxShow?'市价 +'+this.zhisunds:(this.zhisunds && !this.goldzhisun && this.navtabcurrentindex == 0 && buyBoxShow?'市价 -'+this.zhisunds:'未设置'))}}</span></li>
                            <li>止盈<span>{{!this.zhiyingds && this.goldzhiying && this.navtabcurrentindex == 0?parseFloat(this.goldzhiying).toFixed(2):(this.zhiyingds && !this.goldzhiying && this.navtabcurrentindex == 0 && sellBoxShow?'市价 -'+this.zhiyingds:(this.zhiyingds && !this.goldzhiying && this.navtabcurrentindex == 0 && buyBoxShow?'市价 +'+this.zhiyingds:'未设置'))}}</span></li>
                        </div>
                    </ul>
                </div>
                <div class="sellbtn">
                    <p @click="btnremove">取消</p>
                    <p v-preventReClick @click="submit">提交</p>
                </div>
            </div>

        </div>

        <!-- 挂单交易 -->
        <div class="content" v-show="this.navtabcurrentindex == 1">
            <p class="contenttips" :style="{color:getTips == '价格有误，挂单价格至少远离市价200点'?'#FF4F36':'#BBBBBB'}">{{getTips}}</p>
            <div class="list">
                <div class="list-item"  @click="choosetype">
                    <div class="list-item-left">交易类型</div>
                    <div class="list-item-right">{{choosetext}}<span><img src="@/assets/icon-right.png" alt=""></span></div>
                </div>
                <div @click="handledealdate" class="list-item">
                    <div class="list-item-left">有效期</div>
                    <div class="list-item-right">{{dealdatetext}}<span><img src="@/assets/icon-right.png" alt=""></span></div>
                </div>
                <div class="list-item">
                    <div class="list-item-left">挂单价格<span>{{getDealTypePrice}}</span></div>
                    <div class="list-item-right">
                        <div class="main"><img @click="goldgdcut" src="@/assets/cut.png" alt=""></div>
                        <div class="right">
                            <span><input type="num" placeholder="未设置" v-model="goldgdprice" @input="ongoldprice"></span>
                            <span><img @click="goldgdadd" src="@/assets/add.png" alt=""></span>
                            <span @click="goldgdreset">清空</span>
                        </div>
                    </div>
                </div>

                <div class="list-item" v-show="this.$store.state.mt == 5 && showts">
                    <div class="list-item-left">停损限价<span>{{goldyjtsprice}}</span></div>
                    <div class="list-item-right">
                        <div class="main"><img @click="goldtscut" src="@/assets/cut.png" alt=""></div>
                        <div class="right">
                            <span><input type="num" placeholder="未设置" v-model="goldtsprice" @input="ontsprice"></span>
                            <span><img @click="goldtsadd" src="@/assets/add.png" alt=""></span>
                            <span @click="gdtsreset">清空</span>
                        </div>
                    </div>
                </div>

                <div class="list-item">
                    <div class="list-item-left">交易手数</div>
                    <div class="list-item-right">
                        <div class="main"><img @click="gdtotalcut" src="@/assets/cut.png" alt=""></div>
                        <div class="right">
                        <span><input type="num" placeholder="手数" v-model.number="gdinitlot" @input="gdoninput" @focus="gdonfocuss" @blur="gdonblur"></span>
                            <span><img @click="gdtotaladd" src="@/assets/add.png" alt=""></span>
                            <span @click="gdresetnum()">清空</span>
                        </div>
                    </div>
                </div>
            </div>
            <dealprices 
            :gdzhisundss='gdzhisundss' 
            :gdzhiyingdss='gdzhiyingdss' 
            :gdgoldzhisun='gdgoldzhisun' 
            :gdgoldzhiying='gdgoldzhiying' 
            @gdzhisunds='gdzsds' 
            @gdzhiyingds='gdzyds'  
            :goldDealTypePrice='goldDealTypePrice' 
            :navtabcurrentindex='navtabcurrentindex' 
            :gdyfk='gdyfk' 
            @gdlotsarr='gdlotsarrs' 
            :gdinitlot='Number(this.gdinitlot)' 
            @zhiying='mentss' 
            @zhisun='mentsss' 
            :goldgdprice ='goldgdprice'
            :goldtsprice ="goldtsprice" style="margin-top:12px;">
            </dealprices>
            <div @click="handlexd" class="xiadanbtn">下单</div>
            <div style="height:50px"></div>

            <!-- 挂单弹出框 -->
            <div class="mask" @click="handlegdmask" v-show="gdshows || choosetypeshow || dateboxshow || timepickershow"></div>
            <div class="Sellbox" v-show="gdshows">
                <div class="title">确认订单信息</div>
                <div class="sellContent">
                    <div class="top">
                        <span :style="{backgroundColor:choosetext == '限价卖出' || choosetext == '止损卖出' || choosetext == '停损限价卖出'?'#17CF84':(choosetext == '限价买入' || choosetext == '止损买入' || choosetext == '停损限价买入'?'#FF4F36':'#999999')}">{{choosetext}}</span>
                        <span>{{this.$store.state.goldindex?'伦敦金':'伦敦银'}}</span>
                        <span>{{gdinitlot+'手'}}</span>
                    </div>
                    <ul>
                        <div class="left">
                            <li>交易价格<span>{{parseFloat(this.goldgdprice).toFixed(2)}}</span></li>
                            <li>最新价格<span>{{choosetext == '限价买入' || choosetext == '止损买入'?this.$store.state.goldBuy.toFixed(2):this.$store.state.goldSell.toFixed(2)}}</span></li>
                            <li v-show="this.$store.state.mt == 5 && showts">停损限价<span>{{parseFloat(goldtsprice).toFixed(2)}}</span></li>
                            <li>有效期:{{dealdatetext}}</li>
                        </div>
                        <div class="right">
                            <li>止损<span>{{this.gdgoldzhisun && this.navtabcurrentindex == 1?parseFloat(this.gdgoldzhisun).toFixed(2):(this.navtabcurrentindex == 1 && this.gdzhisundss?parseFloat(this.getdstopricezs).toFixed(2):'未设置')}}</span></li>
                            <li>止盈<span>{{this.gdgoldzhiying && this.navtabcurrentindex == 1?parseFloat(this.gdgoldzhiying).toFixed(2):(this.navtabcurrentindex == 1 && this.gdzhiyingdss?parseFloat(this.getdstopricezy).toFixed(2):'未设置')}}</span></li>
                            <li>&nbsp;</li>
                        </div>
                    </ul>
                    <!-- <div class="bottom">有效期:{{dealdatetext}}</div> -->
                </div>
                <div class="sellbtn">
                    <p @click="btnremove">取消</p>
                    <p v-preventReClick @click="gdsubmit">提交</p>
                </div>
            </div>

            <!-- 交易类型弹出框 -->
            <div class="chooseTpbox" v-show="choosetypeshow">
                <div class="title">选择交易类型 <img class="close" @click="handleClose" src="@/assets/close.png" alt=""></div>
                <div class="list">
                    <div v-for="(item,index) in choosetypelist" :key="index" class="item" @click="handlechoose(index)">{{item.title}}<img v-show="selectIndex==index?true:false" src="@/assets/correct.png" alt=""></div>
                </div>
            </div>

            <!-- 交易日期弹出框 -->
            <div class="databox" v-show="dateboxshow">
                <div class="title">选择挂单有效期 <img class="close" @click="handleClose" src="@/assets/close.png" alt=""></div>
                <div class="list">
                    <div v-for="(item,index) in datelist" :key="index" class="item" @click="handledate(index)">{{item.title}}<img v-show="dateselectIndex==index?true:false" src="@/assets/correct.png" alt=""></div>
                    <div style="height:56.33px;line-height:56.33px;color:#333333;font-size:16px;border-bottom: 1px solid #F5F5F5" @click="customize()">自定义</div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import pako from 'pako'
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
import {dealsj,getsymbol,utf8ByteToUnicodeStr} from '@/utils/socket2.js';
import moment from 'moment'
import dealprices from '@/components/dealprice'
import {toFixed2} from '@/utils/tofixed'
export default {
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    components:{
        dealprices,
    },
    name:'golds',
    data(){
        return{
            loadingShow:false,//开启加载提示
            changeArr:[{'name':'市价交易'},{'name':'挂单交易'}],
            navtabcurrentindex:0,
            yfk:this.$store.state.isprofession?50.00:163.79,//初始参考预付款
            gdyfk:this.$store.state.isprofession?50.00:163.79,//挂单初始参考预付款
            goldgdprice:null, //挂单价格
            goldtsprice:null,//停价止损价格
            tsflag:true,//停价止损第一次点击默认
            gdflag: true,//挂单第一次点击默认
            gdclicktotal:0,//挂单点击总次数
            tsclicktotal:0,//停价止损点击总次数
            totallot:20,//最大手数
            initlot:0.05,//初始手数
            gdinitlot:0.05,//挂单初始手数
            // num:5, //每次加减的倍数
            sellBoxShow:false,//卖出价弹出框
            buyBoxShow:false,//买入价弹出框
            gdshows:false,//挂单弹出框

            goldzhiying:null,//dealprice传过来的黄金止盈价
            goldzhisun:null,//dealprice传过来的黄金止损价

            gdgoldzhiying:null,//挂单止盈
            gdgoldzhisun:null,//挂单止损

            choosetext:'限价买入',//初始交易类型
            choosetypeshow:false, //选择交易类型弹框
            choosetypelist:this.$store.state.mt==5?[{'id':'0','title':'限价买入','type':'0'},{'id':'1','title':'限价卖出','type':'1'},{'id':'2','title':'止损买入','type':'2'},{'id':'3','title':'止损卖出','type':'3'},{'id':'4','title':'停损限价买入','type':'4'},{'id':'5','title':'停损限价卖出','type':'5'}]:[{'id':'0','title':'限价买入','type':'0'},{'id':'1','title':'限价卖出','type':'1'},{'id':'2','title':'止损买入','type':'2'},{'id':'3','title':'止损卖出','type':'3'}],
            selectIndex:0, //交易类型选择

            dealdatetext:'长期有效', //初始交易日期
            dateboxshow:false, //选择交易类型弹框
            datelist:[{'id':'0','title':'长期有效'},{'id':'1','title':'本日有效'},{'id':'2','title':'本周有效'},{'id':'3','title':'本月有效'}],
            dateselectIndex:0, //交易类型选择

            submitflags:false,//市价提交请求开关
            gdsubmitflags:false,//挂单请求开关

            zhisunds:null,//传过来的市价止损点数
            zhiyingds:null,//传过来的市价止盈点数

            gdzhisundss:null,//传过来的挂单止损点数
            gdzhiyingdss:null,//传过来的挂单止盈点数

            goldDealTypePrice:null,//黄金动态变化的挂单价格传给子组件，为了控制当没有金额时，止损止盈input。

            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            timepickershow:false,
            changetime:null,
            showts:false,//是否展示停损限价

        }
    },
    

    methods:{

        handletab(index){
            this.navtabcurrentindex = index
        },

        handlemask(){
            this.sellBoxShow = false
            this.buyBoxShow = false
        },

        handlegdmask(){
            this.gdshows = false
            this.choosetypeshow = false
            this.dateboxshow = false
            this.timepickershow = false
        },

         // 监听市价交易手数输入框
        oninput(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.initlot = e.target.value
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(1000,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 2 * this.$store.state.goldBuy)
            }
        },

        onfocuss(e){
            e.target.value=''
            this.initlot = e.target.value
        },

        onblur(e){
            this.initlot = e.target.value
        },
        // 监听市价交易手数输入框



        // 监听挂单交易手数输入框
        gdoninput(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.gdinitlot = e.target.value
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(1000,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 2 * this.goldgdprice)
            }
        },

        gdonfocuss(e){
            e.target.value=''
            this.gdinitlot = e.target.value
        },

        gdonblur(e){
            this.gdinitlot = e.target.value
        },
        // 监听挂单交易手数输入框


        
        NumberAdd(arg1, arg2){
            var r1,r2,m,n
            try{
                r1 = arg1.toString().split('.')[1].length
            } catch (e){
                r1 = 0
            }
            try{
                r2 = arg2.toString().split('.')[1].length
            } catch (e){
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = ( r1 >= r2 ) ? r1 : r2
            return ((arg1 * m + arg2 * m ) / m ).toFixed(n)
        },

        Sub(arg1, arg2) {
            arg1 = parseFloat(arg1);
            arg2 = parseFloat(arg2);
            var r1, r2, m, n;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2));
            //动态控制精度长度
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m ) / m ).toFixed(n)
        },

        // 市场交易手数加减
        totaladd(){
            var lots = 0.05 
            this.initlot = this.NumberAdd(this.initlot,lots)
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(1000,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 2 * this.$store.state.goldBuy)
            }
        },

        totalcut(){
            if(this.initlot <= 0.05){
                this.initlot = 0.05 
                if(this.$store.state.isprofession){
                    this.yfk = Number(this.yfk = this.gets(1000,'initlot'))
                }else{
                    this.yfk = Number(this.yfk = this.initlot * 2 * this.$store.state.goldBuy)
                }
                return false
            }
            var lots = 0.05 
            this.initlot = Number(this.Sub(this.initlot,lots))
            if(Number(this.Sub(this.initlot,lots)) <= 0.05){
                this.initlot = 0.05
            }
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(1000,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 2 * this.$store.state.goldBuy)
            }
        },
        resetnum(){
            this.initlot = null
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(1000,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 2 * this.$store.state.goldBuy)
            }
        },
        // 市场交易手数加减

        // 挂单交易手数加减
        gdtotaladd(){
            var lots = 0.05
            this.gdinitlot = this.NumberAdd(this.gdinitlot,lots)
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(1000,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 2 * this.goldgdprice)
            }
        },
       
        gdtotalcut(){
            if(this.gdinitlot <= 0.05){
                this.gdinitlot = 0.05 
                if(this.$store.state.isprofession){
                    this.gdyfk = Number(this.gdyfk = this.gets(1000,'gdinitlot'))
                }else{
                    this.gdyfk = Number(this.gdyfk = this.gdinitlot * 2 * this.goldgdprice)
                }
                return false
            }
            var lots = 0.05 
            this.gdinitlot = Number(this.Sub(this.gdinitlot,lots))
            if(Number(this.Sub(this.gdinitlot,lots)) <= 0.05){
                this.gdinitlot = 0.05
            }
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(1000,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 2 * this.goldgdprice)
            }
        },
        gdresetnum(){
            this.gdinitlot = null
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(1000,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 2 * this.goldgdprice)
            }
        },
        // 挂单交易手数加减


        // 获取预付款差值
        gets(val,lot){
            var s = ''
            return s = (this[lot] * val).toFixed(2)
        },

        // 监听黄金页面挂单价格输入框
        ongoldprice(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.goldgdprice = e.target.value
            this.gdflag = false
        },
        // 监听黄金页面挂单价格输入框

        // 挂单交易价格加减
        goldgdadd(){
            var initnum = 0.01
            if(this.gdclicktotal == 0 && this.gdflag == true){

                if(this.choosetext == '限价买入'){
                    // 买入市价-$2.00
                    this.goldgdprice = this.$store.state.goldBuy - (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == '限价卖出'){
                    // 卖出市价+$2.00
                    this.goldgdprice = this.$store.state.goldSell + (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == '止损买入'){
                    // 买入市价+$2.00
                    this.goldgdprice = this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == '止损卖出'){
                    // 卖出市价-$2.00
                    this.goldgdprice = this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == "停损限价买入"){
                    // 买入市价+$2.00
                    this.goldgdprice = this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == "停损限价卖出"){
                    // 卖出市价-$2.00
                    this.goldgdprice = this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)
                }

            }
            this.gdclicktotal++
            this.goldgdprice = parseFloat(this.NumberAdd(this.goldgdprice,initnum)).toFixed(2)
        },

        goldgdcut(){
            var initnum = 0.01
            if(this.gdclicktotal == 0 && this.gdflag == true){
                if(this.choosetext == '限价买入'){
                    // 买入市价-$2.00
                    this.goldgdprice = this.$store.state.goldBuy - (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == '限价卖出'){
                    // 卖出市价+$2.00
                    this.goldgdprice = this.$store.state.goldSell + (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == '止损买入'){
                    // 买入市价+$2.00
                    this.goldgdprice = this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == '止损卖出'){
                    // 卖出市价-$2.00
                    this.goldgdprice = this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == "停损限价买入"){
                    // 买入市价+$2.00
                    this.goldgdprice = this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)
                }else if(this.choosetext == "停损限价卖出"){
                    // 卖出市价-$2.00
                    this.goldgdprice = this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)
                }

            }
            this.gdclicktotal++
            if(this.goldgdprice <= 0)return false
            this.goldgdprice = parseFloat(this.Sub(this.goldgdprice,initnum)).toFixed(2)
        },

        goldgdreset(){
            this.goldgdprice = null
            this.gdclicktotal = 0
            this.gdflag = true
        },
        // 挂单交易价格加减


        // 监听黄金页面停价止损输入框
        ontsprice(e){
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.goldtsprice = e.target.value
            this.tsflag = false
        },
        // 监听黄金页面停价止损输入框

        goldtsadd(){
            var initnum = 0.01
            if(this.tsclicktotal == 0 && this.tsflag == true){

                this.goldtsprice = Number(this.goldyjtsprice.replace(/<|>/g,''))

            }
            this.tsclicktotal++
            this.goldtsprice = parseFloat(this.NumberAdd(this.goldtsprice,initnum)).toFixed(2)
        },

        goldtscut(){
            var initnum = 0.01
            if(this.tsclicktotal == 0 && this.tsflag == true){

                this.goldtsprice = Number(this.goldyjtsprice.replace(/<|>/g,''))

            }
            this.tsclicktotal++
            if(this.goldtsprice <= 0)return false
            this.goldtsprice = parseFloat(this.Sub(this.goldtsprice,initnum)).toFixed(2)
        },

        gdtsreset(){
            this.goldtsprice = null
            this.tsclicktotal = 0
            this.tsflag = true
        },

        // dealprice子组件传过来的初始手数
        lotsarrs(val){
            this.initlot = val.toFixed(2)
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(1000,'initlot'))
            }else{
                this.yfk = Number(this.yfk = this.initlot * 2 * this.$store.state.goldBuy)
            }
        },
        // dealprice子组件传过来的挂单初始手数
        gdlotsarrs(val){
            this.gdinitlot = val.toFixed(2)
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(1000,'gdinitlot'))
            }else{
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 2 * this.goldgdprice)
            }
        },

        // dealprice子组件传过来的止盈价
        mentss(val){
            if(this.navtabcurrentindex == 0){
                this.goldzhiying = val
            }else if(this.navtabcurrentindex == 1){
                this.gdgoldzhiying = val
            }
        },

        // dealprice子组件传过来的止损价
        mentsss(val){
            if(this.navtabcurrentindex == 0){
                this.goldzhisun = val
            }else if(this.navtabcurrentindex == 1){
                this.gdgoldzhisun = val
            }
        },

        // dealprice子组件传过来的市价止损点数
        getzhisunds(val){
            this.zhisunds = Number(val)
        },

        // dealprice子组件传过来的市价止盈点数
        getzhiyingds(val){
            this.zhiyingds = val

        },

        //dealprice子组件传过来的挂单止损点数
        gdzsds(val){
            this.gdzhisundss = val
        },

        // dealprice子组件传过来的挂单止盈点数
        gdzyds(val){
            this.gdzhiyingdss = val
        },

        // 选择交易类型弹出
        choosetype(){
            this.choosetypeshow = true 
        },

        // 选择交易类型
        handlechoose(index){
            this.selectIndex = index
            this.choosetext = this.choosetypelist[index].title

            if(this.choosetext == "停损限价买入" || this.choosetext == "停损限价卖出"){
                this.showts = true
            }else{
                this.showts = false
            }

            this.choosetypeshow = false

            this.goldgdprice = null //每次切换清空挂单价格
            this.gdclicktotal = 0 //每次清空挂单价格都要重置这个属性
            this.gdflag = true //每次清空挂单价格都要重置这个属性,因为第一次点击加或减要获取行情价
            this.gdinitlot = null //每次切换清空挂单手数

            this.goldtsprice = null //每次选择交易类型清空停价止损价格
            this.tsflag = true //每次选择交易类型清空加减开关
            this.tsclicktotal = 0//每次选择交易类型清空点击次数

            this.gdgoldzhisun = null
            this.gdgoldzhiying = null
            this.gdzhisundss = null
            this.gdzhiyingdss = null

            this.$store.state.dealtype = this.choosetypelist[index].title

        },

        // 关闭交易类型、交易日期弹出框
        handleClose(){
            this.choosetypeshow = false
            this.dateboxshow = false
        },

        // 弹出交易日期
        handledealdate(){
            this.dateboxshow = true
        },

        // 选择交易日期
        handledate(index){
            this.dateselectIndex = index
            this.dealdatetext = this.datelist[index].title
            this.dateboxshow = false
        },

        // 点击市价卖出
        handleSell(){
            if(this.initlot <= 0){
                this.$toast('请输入手数')
                return false
            }
            this.sellBoxShow = true
            this.buyBoxShow = false
        },

        // 点击市价买入
        handleBuy(){
            if(this.initlot <= 0){
                this.$toast('请输入手数')
                return false
            }
            this.buyBoxShow = true
            this.sellBoxShow = false
        },

        // 取消按钮
        btnremove(){
            this.sellBoxShow = false
            this.buyBoxShow = false
            this.gdshows = false //挂单下单弹框
        },

        // 点击下单
        handlexd(){
            if(this.gdinitlot <= 0){
                this.$toast('请输入手数')
                return false
            }
            if(this.goldgdprice <= 0){
                this.$toast('请输入正确的价格')
                return false
            }
            if(this.choosetext == "停损限价买入" && !this.goldtsprice){
                this.$toast("请输入停损价格")
                return false
            }
            if(this.choosetext == "停损限价卖出" && !this.goldtsprice){
                this.$toast("请输入停损价格")
                return false
            }
            this.gdshows = true //挂单下单弹框

        },

        // 点击自定义
        customize(){
            this.timepickershow = true
            this.dateboxshow = false
        },

        // 时间选定
        onchange(val){
            this.changetime = val.getValues()[0]+'-'+val.getValues()[1]+'-'+val.getValues()[2]+' '+val.getValues()[3]+':'+val.getValues()[4]
        },

        // 时间确认
        confirmPicker(){
            if(this.changetime){
                this.dealdatetext = this.changetime
            }
            this.timepickershow = false
            this.dateselectIndex = 999999 //消除选择标志
        },

        // 时间取消
        confirmremove(){
            this.timepickershow = false
        },

        // 开启websocket
        initWebpack(){

            var that = this

            if (that.global.ws && that.global.ws.readyState == 1 && that.$store.state.goldindex) {

                getsymbol(that.global.ws) //可用交易品类 里面也有黄金白银挂单距离
                that.global.ws.onmessage = that.onmessageg   

            }

        },

        // 挂单交易提交下单
        gdsubmit(){
            var that = this
            that.global.ws.onmessage = that.onmessageg
            that.gdsubmitflags = true
            var op = null //成交类型
            var stoploss = null // 止损参数
            var takeprofit = null //止盈参数

            var stoplimit = this.$store.state.mt == 5 && this.showts && this.goldtsprice?this.goldtsprice:0

            stoploss = that.gdgoldzhisun?that.gdgoldzhisun:(this.gdzhisundss?that.getdstopricezs:0)
            takeprofit = that.gdgoldzhiying?that.gdgoldzhiying:(this.gdzhiyingdss?that.getdstopricezy:0)
            that.choosetext == '限价买入'?0:(this.choosetext == '限价卖出'?1:(this.choosetext == '止损买入'?2:(this.choosetext == '止损卖出'?3:'')))
            
            op = that.choosetext == '限价买入'?2:(that.choosetext == '限价卖出'?3:(that.choosetext == '止损买入'?4:(that.choosetext == '止损卖出'?5:(that.choosetext == "停损限价买入"?6:(that.choosetext == "停损限价卖出"?7:"")))))

            var getdatetime = null

            if (that.global.ws && that.global.ws.readyState == 1 && that.gdsubmitflags == true && that.navtabcurrentindex == 1) {

                that.loadingShow = true //开启加载提示


                    if(this.dealdatetext == '本日有效'){
                        getdatetime = moment().endOf('day').format('X')
                    }else if(this.dealdatetext == '本周有效'){
                        getdatetime = moment().endOf('week').format('X')
                    }else if(this.dealdatetext == '本月有效'){
                        getdatetime = moment().endOf('month').format('X')
                    }else if(this.dealdatetext == '长期有效'){
                        getdatetime = 0
                    }else{
                        getdatetime = Number(moment(this.dealdatetext).format("X"))
                    }
                

                dealsj(this.$store.state.isprofession?'XAU':'GOLD',op,that.gdinitlot,stoploss,takeprofit,that.goldgdprice,getdatetime,that.global.ws,stoplimit)
            }

        },

        // 市价交易提交下单
        submit(){
            var that = this
            that.global.ws.onmessage = that.onmessageg
            that.submitflags = true
            var op = null //买入或卖出
            var stoploss = null // 止损参数
            var takeprofit = null //止盈参数

            op = that.sellBoxShow?1:(that.buyBoxShow?0:'')

            stoploss = that.goldzhisun?that.goldzhisun:(that.zhisunds?that.getsjdszs:0)
            takeprofit = that.goldzhiying?that.goldzhiying:(that.zhiyingds?that.getsjdszy:0)

            if (that.global.ws && that.global.ws.readyState == 1 && that.submitflags == true && that.navtabcurrentindex == 0) {

                that.loadingShow = true //开启加载提示

                dealsj(this.$store.state.isprofession?'XAU':'GOLD',op,that.initlot,stoploss,takeprofit,0,0,that.global.ws,0)
            }
        },

        onmessageg(evt){
            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);
            var obj = JSON.parse(strData)


            // 区分专业者和非专业者
            if(obj.act == 'get_enable'){
                obj.arr.forEach(element => {
                    if(element.symbol == 'XAU' || element.symbol == 'GOLD'){
                        this.$store.state.goldstopsLevel = element.stopsLevel
                        this.$store.state.dealgold = element.symbol == 'XAU'?'XAU':(element.symbol == 'GOLD'?'GOLD':'')
                    }else if(element.symbol == 'XAG' || element.symbol == 'SILVER'){
                        this.$store.state.silverstopsLevel = element.stopsLevel
                        this.$store.state.dealsilver = element.symbol == 'XAG'?'XAG':(element.symbol == 'SILVER'?'SILVER':'')
                    }

                });

                if(this.$store.state.dealgold == 'XAU' && this.$store.state.dealsilver == 'XAG'){
                    this.$store.state.isprofession = true
                }else if(this.$store.state.dealgold == 'GOLD' && this.$store.state.dealsilver == 'SILVER'){
                    this.$store.state.isprofession = false
                }


            }

            if(obj.act == 'order_send' && obj.success  && this.navtabcurrentindex == 0){

                this.$toast('下单成功')
                this.buyBoxShow = false //弹框
                this.sellBoxShow = false //弹框
                this.submitflags = false //接受完数据关闭开关
                this.loadingShow = false //关闭加载提示

                this.$router.push({path:'/hold'})

            }else if(obj.act == 'order_send' && !obj.success   && this.navtabcurrentindex == 0){

                this.$toast(obj.msg)
                this.buyBoxShow = false //弹框
                this.sellBoxShow = false //弹框
                this.submitflags = false //接受完数据关闭开关
                this.loadingShow = false //关闭加载提示
            }

            if(obj.act == 'order_send' && obj.success  && this.navtabcurrentindex == 1){

                this.$toast('下单成功')
                this.timepickershow = false
                this.gdsubmitflags = false
                this.gdshows = false //弹窗
                this.loadingShow = false //关闭加载提示

                this.$router.push({path:'/pending-order'})

            }else if(obj.act == 'order_send' && !obj.success  && this.navtabcurrentindex == 1){
                this.$toast(obj.msg)
                this.gdshows = false //弹窗
                this.timepickershow = false
                this.gdsubmitflags = false
                this.loadingShow = false //关闭加载提示
            }

            // 全局订单推送
            if(obj.act == 'order_update' && obj.grp == 'sub'){

                if(this.$store.state.login){

                    this.$store.state.ordertipshow = true
                    
                    this.$store.state.ordertype = obj.msg.replace(/[0-9]/g,"")

                    this.$store.state.orderticket = obj.msg.replace(/[^\d.]/g,"");
                    this.$store.state.ordersymbol = obj.data.symbol
                    this.$store.state.orderdeal = obj.data.orderDirection
                    this.$store.state.orderopenprice = obj.data.openPrice
                    this.$store.state.ordercloseprice = obj.data.closePrice
                    this.$store.state.orderlots = obj.data.lots
                    this.$store.state.orderopentime = obj.data.openTime
                    this.$store.state.orderclosetime = obj.data.closeTime

                    setTimeout(() => {

                        this.$store.state.ordertipshow = false

                    }, 5000)
                }

                // setTimeout(() => { //加定时器是避免市价下单和挂单的navtabcurrentindex 在未请求下单成功刷新了页面就变成0导致走错页面

                //     this.reload();

                // }, 1000)

            }
 
        },
        
    },

    watch:{

        // 通过store的专业者和非专业者监听预付款和挂单预付款初始值
        'isisprofession'(val){
            if(val){
                this.yfk = Number(this.yfk = this.gets(1000,'initlot'))
                this.gdyfk = Number(this.gdyfk = this.gets(1000,'gdinitlot'))
            }else{
                this.yfk = Number(this.yfk = this.initlot * 2 * this.$store.state.goldBuy)
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 2 * this.goldgdprice)
            }
        },

        'goldgdprice'(val){
            if(val){
                val = parseFloat(val).toFixed(2)
            }

        }
    },

    computed:{

        ...mapGetters([
            'isisprofession'
        ]),

        // 计算买入市场价和卖出市场价点差
        spread(){
            return (this.$store.state.goldBuy - this.$store.state.goldSell) * 100
        },

        // 计算最新卖价小数点保留2位
        getparsefloatsell(){
            return parseFloat(this.$store.state.goldSell).toFixed(2)
        },

        // 计算最新买价小数点保留2位
        getparsefloatbuy(){
            return parseFloat(this.$store.state.goldBuy).toFixed(2)
        },

        // 计算挂单停损限价价格
        goldyjtsprice(){
            if(this.goldgdprice){
                if(this.choosetext == "停损限价买入"){
                    return "<" + (Number(this.goldgdprice) - (this.$store.state.goldstopsLevel/100)).toFixed(2)
                }else if(this.choosetext == "停损限价卖出"){
                    return ">" + (Number(this.goldgdprice) + (this.$store.state.goldstopsLevel/100)).toFixed(2)
                }
            }else{
                return null
            }
        },

        // 计算挂单交易类型跳动价格
        getDealTypePrice(){
            if(this.choosetext == '限价买入'){
                // 买入市价-$2.00
                this.goldDealTypePrice = this.$store.state.goldBuy - (this.$store.state.goldstopsLevel/100)
                return '<' + (this.$store.state.goldBuy - (this.$store.state.goldstopsLevel/100)).toFixed(2)
            }else if(this.choosetext == '限价卖出'){
                // 卖出市价+$2.00
                this.goldDealTypePrice = this.$store.state.goldSell + (this.$store.state.goldstopsLevel/100)
                return '>' + (this.$store.state.goldSell + (this.$store.state.goldstopsLevel/100)).toFixed(2)
            }else if(this.choosetext == '止损买入'){
                // 买入市价+$2.00
                this.goldDealTypePrice = this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)
                return '>' + (this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)).toFixed(2)
            }else if(this.choosetext == '止损卖出'){
                // 卖出市价-$2.00
                this.goldDealTypePrice = this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)
                return '<' + (this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)).toFixed(2)
            }else if(this.choosetext == "停损限价买入"){
                this.goldDealTypePrice = this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)
                return '>' + (this.$store.state.goldBuy + (this.$store.state.goldstopsLevel/100)).toFixed(2)
            }else if(this.choosetext == "停损限价卖出"){
                this.goldDealTypePrice = this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)
                return '<' + (this.$store.state.goldSell - (this.$store.state.goldstopsLevel/100)).toFixed(2)
            }
        },

        // 计算提示客户价格输入正确与否
        getTips(){
            var s = this.getDealTypePrice.replace(/<|>/g,'')
            if(this.choosetext == '限价买入'){
                if(this.goldgdprice <= s){
                    return '挂单模式下行情剧烈波动时，成交价格会更有利或更不利。'
                }else{
                    return '价格有误，挂单价格至少远离市价200点'
                }
            }else if(this.choosetext == '限价卖出'){
                if(this.goldgdprice >= s){
                    return '挂单模式下行情剧烈波动时，成交价格会更有利或更不利。'
                }else{
                    return '价格有误，挂单价格至少远离市价200点'
                }
            }else if(this.choosetext == '止损买入'){
                if(this.goldgdprice >= s){
                    return '挂单模式下行情剧烈波动时，成交价格会更有利或更不利。'
                }else{
                    return '价格有误，挂单价格至少远离市价200点'
                }
            }else if(this.choosetext == '止损卖出'){
                if(this.goldgdprice <= s){
                    return '挂单模式下行情剧烈波动时，成交价格会更有利或更不利。'
                }else{
                    return '价格有误，挂单价格至少远离市价200点'
                }
            }else if(this.choosetext == "停损限价买入"){
                if(this.goldgdprice >= s){
                    return '挂单模式下行情剧烈波动时，成交价格会更有利或更不利。'
                }else{
                    return '价格有误，挂单价格至少远离市价200点'
                }
            }else if(this.choosetext == "停损限价卖出"){
                if(this.goldgdprice <= s){
                    return '挂单模式下行情剧烈波动时，成交价格会更有利或更不利。'
                }else{
                    return '价格有误，挂单价格至少远离市价200点'
                }
            }
        },

        // 计算市价下单止盈止损点数换算成价格
        getsjdszs(){
            if(this.buyBoxShow){
                 return this.Sub(this.$store.state.goldBuy,(this.zhisunds / 100).toFixed(2))
            }else if(this.sellBoxShow){
                return this.NumberAdd(this.$store.state.goldSell,(this.zhisunds / 100).toFixed(2))
            }
        },

        getsjdszy(){
            if(this.buyBoxShow){
                return this.NumberAdd(this.$store.state.goldBuy,(this.zhiyingds / 100).toFixed(2))
            }else if(this.sellBoxShow){
                return this.Sub(this.$store.state.goldSell,(this.zhiyingds / 100).toFixed(2))
            }
        },

        // 计算挂单下单止盈止损点数换算成价格
        getdstopricezs(){
                if(this.$store.state.dealtype == '限价买入'){
                    return this.Sub(this.goldgdprice,(this.gdzhisundss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '限价卖出'){
                    return this.NumberAdd(this.goldgdprice,(this.gdzhisundss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损买入'){
                    return this.Sub(this.goldgdprice,(this.gdzhisundss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损卖出'){
                    return this.NumberAdd(this.goldgdprice,(this.gdzhisundss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价买入"){
                    return this.Sub(this.goldtsprice,(this.gdzhisundss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价卖出"){
                    return this.NumberAdd(this.goldtsprice,(this.gdzhisundss / 100).toFixed(2))
                }
        },

        getdstopricezy(){
                if(this.$store.state.dealtype == '限价买入'){
                   return  this.NumberAdd(this.goldgdprice,(this.gdzhiyingdss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '限价卖出'){
                   return  this.Sub(this.goldgdprice,(this.gdzhiyingdss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损买入'){
                   return  this.NumberAdd(this.goldgdprice,(this.gdzhiyingdss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损卖出'){
                   return  this.Sub(this.goldgdprice,(this.gdzhiyingdss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价买入"){
                   return  this.NumberAdd(this.goldtsprice,(this.gdzhiyingdss / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价卖出"){
                   return  this.Sub(this.goldtsprice,(this.gdzhiyingdss / 100).toFixed(2))
                }
        },

        // 计算提交时间
        // getdatetime(){
        //     if(this.dealdatetext == '本日有效'){
        //         return moment().endOf('day').format('X')
        //     }else if(this.dealdatetext == '本周有效'){
        //         return moment().endOf('week').format('X')
        //     }else if(this.dealdatetext == '本月有效'){
        //         return moment().endOf('month').format('X')
        //     }else if(this.dealdatetext == '长期有效'){
        //         return 0
        //     }else{
        //         return (new Date(this.dealdatetext)).getTime() / 1000
        //     }
        // }


    },
    mounted(){
        this.initWebpack() //开启ws连接
        this.$emit('num',0)
    }
}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}
    .mask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 887;}
    .content{background: #FFFFFF;}
    .navbox{background-color: #FFFFFF;margin: 0 auto;}
    .nav{width: 200px;height: 32px;display: flex;align-items: center;margin: 0 auto;padding: 12px 0;}
    .nav p{flex: 1;display: flex;justify-content: center;align-items: center;font-size: 14px;}
    .nav p:nth-of-type(1){border-top-right-radius: 0;border-bottom-right-radius: 0;}
    .nav p{height: 100%; border: 1px solid #FF4F36;color: #FF4F36;border-radius: 15.83px;}
    .nav p:nth-of-type(2){border-top-left-radius: 0;border-bottom-left-radius: 0;}
    .navactived{background-color: #FF4F36 !important;color: #FFFFFF !important;}
    .content .contenttips{color: #BBBBBB;font-size: 12px;text-align: center;padding-bottom: 16px;}
    .content .price{margin: 0 auto;display: flex;justify-content: center;align-items: center;}
    .content .price .left{display: flex;text-align: center;flex-direction: column;}
    .content .price .left p:nth-of-type(1){color: #999999;font-size: 14px;}
    .content .price .left p:nth-of-type(2){color: #17CF84;font-size: 24px;font-weight: bold;}
    .content .price .main{color: #BBBBBB;font-size: 12px;width: 60px;height: 44px;background-color: #F8F8F8;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0 31.33px;}
    .content .price .right{display: flex;text-align: center;flex-direction: column;}
    .content .price .right p:nth-of-type(1){color: #999999;font-size: 14px;}
    .content .price .right p:nth-of-type(2){color: #FF4F36;font-size: 24px;font-weight: bold;}
    
    .content .dealbox{height: 50px;display: flex;justify-content: space-between;align-items: center;margin: 0 16px;border-bottom: 1px solid #EEEEEE;margin-bottom: 13px;}
    .content .dealbox .ctrlbox{flex: 1;display: flex;justify-content: flex-end;}
    .content .dealbox .left{display: flex;align-items: center;flex: 1;}
    .content .dealbox .left p{color: #333333;font-size: 14px;}
    .content .dealbox .left p span{color: #999999;padding-left: 9px;font-size: 12px;}
    .content .dealbox .main img{width: 24px;height: 24px;display: block;margin-left: 15px;}
    .content .dealbox .right{display: flex;justify-content: center;align-items: center;}
    .content .dealbox .right img{width: 24px;height: 24px;display: block;margin-right: 10.33px;}
    .content .dealbox .right span:nth-of-type(1){flex: 1;width: 88px;}
    .content .dealbox .right span:nth-of-type(1) input{text-align: center; color: #333333 !important;font-size: 16px !important;font-weight: bold !important;width: 100%;border: none;outline: none;}
    .content .dealbox .right span:nth-of-type(3){color: #999999;font-size: 14px;}

    .content .buybox{height: 44px;margin: 0 15px auto;display: flex;justify-content: space-between;align-items: center;margin-top: 15px;padding-bottom: 100px;}
    .content .buybox .sell{width: 48.3%; height: 44px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 16px;background-color: #17CF84;border-radius: 22px;}
    .content .buybox .buy{width: 48.3%; height: 44px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 16px;background-color: #FF4F36;border-radius: 22px;}

    /* 挂单交易 */
    .list{padding: 0 15px;}
    .list-item{border-bottom: 1px solid #EEEEEE;height: 44px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 14px;}
    .list-item-left{display: flex;justify-content: flex-start;align-items: center;}
    .list-item-left span{color: #999999;font-size: 12px;padding-left: 8px;}
    .list-item-right{font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
    .list-item-right span img{width: 16px;height: 16px;display: block;margin-top: 2px;}

    .list-item-right {height: 50px;display: flex;justify-content: space-between;align-items: center;}
    .list-item-right  .left{display: flex;align-items: center;}
    .list-item-right  .left p{color: #333333;font-size: 14px;}
    .list-item-right  .left p span{color: #999999;padding-left: 9px;font-size: 12px;}
    .list-item-right  .main img{width: 24px;height: 24px;display: block;}
    .list-item-right  .right{display: flex;justify-content: center;align-items: center;}
    .list-item-right  .right img{width: 24px;height: 24px;display: block;margin-right: 10.33px;}
    .list-item-right  .right span:nth-of-type(1){color: #BBBBBB;font-size: 16px;font-weight: bold;width: 60px;padding:0 22px;}
    .list-item-right  .right span:nth-of-type(3){color: #999999;font-size: 14px;text-align: right;}
    .list-item-right input{text-align: center; color: #333333 !important;font-size: 16px !important;font-weight: bold !important;width: 100%;border: none;outline: none;}
    .list-item-right input::placeholder{color: #BBBBBB;}

    .xiadanbtn{margin: 15px 15px 0px 15px;height: 44px;background-image: linear-gradient(to right, #FF6738, #FF4F36);border-radius: 22px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 16px;}


    /* 买卖弹出框 */
    .Sellbox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 888;}
    .Sellbox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .Sellbox .sellContent{margin: 0 15px 15px 15px;background-color: #F8F8F8;border-radius: 12px;}
    .Sellbox .sellContent .top{padding: 12px 0 6px 12px;display: flex;justify-content: flex-start;align-items: center;}
    .Sellbox .sellContent .top span:nth-of-type(1){padding: 2px 4px;height: 18px;border-radius: 9px;background-color: #17CF84;display: block;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;}
    .Sellbox .sellContent .top span:nth-of-type(2){font-size: 16px;color: #333333;font-weight: bold;padding-left: 6.67px;}
    .Sellbox .sellContent .top span:nth-of-type(3){font-size: 16px;color: #333333;font-weight: bold;padding-left: 9.33px;}
    .Sellbox .sellContent ul{padding: 0 0 18px 11.67px;display: flex;justify-content: flex-start;align-items: center;}
    .Sellbox .sellContent ul .right{padding-left: 49px;}
    .Sellbox .sellContent ul li{font-size: 14px;color: #999999;padding-top: 6px;}
    .Sellbox .sellContent ul li span{color: #333333;padding-left: 10.33px;}
    .Sellbox .sellbtn{padding: 0 15px 49px 15px;display: flex;justify-content: space-between;align-items: center;}
    .sellbtn p{width: 48.9%;height: 44px;border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;}
    .sellbtn p:nth-of-type(1){color: #333333;background-color: #EEEEEE;}
    .sellbtn p:nth-of-type(2){color: #FFFFFF;background-image: linear-gradient(to right, #FF4F36, #FF6738);}

    /* 选择交易类型 */
    .chooseTpbox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 888;padding-bottom: 49px;}
    .chooseTpbox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .chooseTpbox .title .close{width: 24px;height: 24px;display: block;position: absolute;left: 15.33px;top: 13px;}
    .chooseTpbox .list{padding-left: 20.33px;}
    .chooseTpbox .list .item{border-bottom: 1px solid #F5F5F5;height: 56.33px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 16px;}
    .chooseTpbox .list .item img{width: 24px;height: 24px;display: block;}

    /* 选择交易日期 */
    .databox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 888;padding-bottom: 49px;}
    .databox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .databox .title .close{width: 24px;height: 24px;display: block;position: absolute;left: 15.33px;top: 13px;}
    .databox .list{padding-left: 20.33px;}
    .databox .list .item{border-bottom: 1px solid #F5F5F5;height: 56.33px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 16px;}
    .databox .list .item img{width: 24px;height: 24px;display: block;}

    /* timepicer */
    .timebox{background-color: #FFFFFF;position: fixed;bottom: 0;width: 100%;z-index: 99999;border-top-left-radius:12px;border-top-right-radius: 12px;}
    .timeboxwrapper{padding: 0 32px;background-color: #FFFFFF;margin-top: 10px;}
    .timeboxwrapper .title{color: #333333;font-weight: bold;font-size: 16px;text-align: center;padding: 17.67px 0 32px 0;}
    .timebox ul{display: flex;}
    .timebox ul li{padding: 0 4px;flex: 1;display: flex;justify-content: center;color:#BBBBBB;font-size: 16px;}
    .timebtn{padding: 0 20px; margin:0 auto;display: flex;justify-content: space-between;align-items: center;margin-top: 25px;margin-bottom: 40px;}
    .timebtn p:nth-of-type(1){width: 48.3%;height: 44px;font-weight: bold;color: #333333;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-color: #EEEEEE;}
    .timebtn p:nth-of-type(2){width: 48.3%;height: 44px;font-weight: bold;color: #FFFFFF;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-image: linear-gradient(to bottom, #FF6738, #FF4F36);}

    /* 加载loading */
    .isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
    .isloginTips p{height: 50px;display: flex;align-items: center;}
    .isloginTips img{width: 40px;height: 40px;display: block;margin-top: 20px;animation:loading 0.75s linear infinite forwards;}
    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/gold.vue